(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    // Splits the description's intro paragraph after its first sentence, wrapping the rest in
    // an accent span (styled above) — an editorial "supporting line" treatment. Guarded and a
    // no-op if the sentence boundary isn't found, so it degrades safely if the Admin-authored
    // description text is ever rewritten.
    var root = document.querySelector('[class*="text_aEtTtq"]');
    var intro = root ? root.querySelector(':scope > p:first-child') : null;
    if (!intro || intro.dataset.editorialSplit === 'true') return;

    var html = intro.innerHTML;
    var splitAt = html.indexOf('. ');
    if (splitAt === -1) return;

    var firstSentence = html.slice(0, splitAt + 1);
    var restSentence = html.slice(splitAt + 2).trim();
    if (!restSentence) return;

    intro.innerHTML = firstSentence + ' <span class="product-description__accent">' + restSentence + '</span>';
    intro.dataset.editorialSplit = 'true';
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"]) return;
  try {
    
  (function () {
    var WRITE_REVIEW_LABEL = 'Lasă o recenzie';
    var PENCIL_PATH = 'M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z';
    var EMPTY_STATE_TEXT = 'Fii prima persoană care își împărtășește experiența.';

    function relabelWriteReviewButton() {
      var button = document.querySelector('[data-testid="write-review-button"]');
      if (!button || button.dataset.editorialRelabeled === 'true') return;

      button.dataset.editorialRelabeled = 'true';
      button.textContent = '';

      var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('class', 'product-reviews__cta-icon');

      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', PENCIL_PATH);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.5');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');

      icon.appendChild(path);
      button.appendChild(icon);
      button.appendChild(document.createTextNode(WRITE_REVIEW_LABEL));
    }

    function relabelEmptyStateText() {
      var text = document.querySelector('.jm-no-reviews-state__text');
      if (!text || text.dataset.editorialRelabeled === 'true') return;

      text.dataset.editorialRelabeled = 'true';
      text.textContent = EMPTY_STATE_TEXT;
    }

    function applyEditorialLabels() {
      relabelWriteReviewButton();
      relabelEmptyStateText();
    }

    applyEditorialLabels();

    var widgetRoot = document.getElementById('judgeme_product_reviews');
    if (widgetRoot) {
      new MutationObserver(applyEditorialLabels).observe(widgetRoot, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
